import { useEffect, useState } from 'react';

import { VersionReviewDialog } from '../../../components/VersionReviewDialog/index.js';
import { getAgentDisplayName } from '../../../types/agent.js';
import type { AgentVersion } from '../../../types/agent.js';

import { AgentSpecDetails } from './AgentSpecDetails.js';
export interface VersionSnapshotDialogProps {
  version: AgentVersion | null;
  onClose: () => void;
}

export function VersionSnapshotDialog({
  version,
  onClose,
}: VersionSnapshotDialogProps) {
  const [shown, setShown] = useState<AgentVersion | null>(version);
  useEffect(() => {
    if (version !== null) setShown(version);
  }, [version]);

  return (
    <VersionReviewDialog
      open={version !== null}
      title={
        shown
          ? `${getAgentDisplayName(shown)} — version ${String(shown.version)}`
          : 'Version'
      }
      onClose={onClose}
    >
      {shown && <AgentSpecDetails agent={shown} />}
    </VersionReviewDialog>
  );
}
